import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { isEmpty } from "./string";

export const getMultiSelectFilterOptions = (searchText, searchResults, selectedMultiples) =>
  isEmpty(searchText) ? Object.values(selectedMultiples || {}) : searchResults;

export const hasActiveSearchResults = (searchText, resultsLength) => !isEmpty(searchText) && resultsLength > 0;

// Shared "not found" content for the diagnosis name/code MultiSelect filters: a spinner while
// fetching, the not-found label once the query is long enough to have run, otherwise nothing.
export const getDiagnosisNotFoundContent = (isFetching, searchText, notFoundText) => {
  if (isFetching) return <Spin size={"small"} indicator={<LoadingOutlined spin />} />;
  if (searchText.length > 3) return notFoundText;
  return "";
};
